import React from 'react';
import { motion } from 'framer-motion';
import { Book, CheckCircle2 } from 'lucide-react';
export function TomosGrid() {
  const tomos = [{
    num: 1,
    title: 'EL MAPA DEL ENEMIGO',
    subtitle: 'Cómo Funciona el Sistema Que Te Frena',
    desc: 'El BCU, el Clearing, los estudios jurídicos y el mercado de carteras de deuda. Antes de actuar, necesitás entender el sistema completo.',
    color: 'from-blue-900/40'
  }, {
    num: 2,
    title: 'DERECHO AL OLVIDO',
    subtitle: 'La Herramienta Legal Más Poderosa y Menos Conocida',
    desc: 'Plazos de caducidad, formularios oficiales y la carta lista para enviar que elimina registros sin pagar un peso — cuando ya caducaron por ley.',
    color: 'from-emerald-900/40'
  }, {
    num: 3,
    title: 'EL ESCUDO LEGAL',
    subtitle: 'Cómo Detener el Acoso y Blindar Tu Sueldo',
    desc: 'Scripts exactos para responder llamadas de estudios. El mínimo inembargable. La carta de cese. Cómo denunciar ante Defensa del Consumidor.',
    color: 'from-amber-900/40'
  }, {
    num: 4,
    title: 'OPERATIVO LIMPIEZA',
    subtitle: 'El Protocolo Paso a Paso Para la Baja Registral',
    desc: 'Calendario de 8 semanas. Formularios oficiales. Casos especiales: garante, divorcio, herencia. Verificación de la baja. Todo cubierto.',
    color: 'from-purple-900/40'
  }, {
    num: 5,
    title: 'LA GRAN QUITA',
    subtitle: 'Negociá y Pagá Entre el 20% y el 50% de lo Reclamado',
    desc: 'El Método Punto Final. El valor real de tu deuda. Scripts de negociación telefónica y presencial. El modelo de acuerdo que te protege.',
    color: 'from-red-900/40'
  }, {
    num: 6,
    title: 'VIDA POST-CLEARING',
    subtitle: 'Volvé a Ser Sujeto de Crédito en 90 Días',
    desc: 'Plan de reconstrucción crediticia. Primera tarjeta. Las 5 herramientas financieras esenciales. El Sistema Anti-Clearing permanente.',
    color: 'from-cyan-900/40'
  }];
  const features = ['Protocolo paso a paso listo para ejecutar', 'Plantillas y cartas legales listas para completar', 'Checklists de verificación', 'Casos prácticos reales del contexto uruguayo', 'Formularios oficiales adaptados a las leyes vigentes', 'Guiones exactos de lo que decir y lo que NO decir', '100% adaptado a Ley 18.331, 17.250, 17.829 y CGP Uruguay', 'Lenguaje claro — sin tecnicismos legales innecesarios'];
  return <section className="py-12 md:py-20 px-4 bg-brand-light relative" data-id="element-334">
      <div className="max-w-5xl mx-auto" data-id="element-335">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-336">
          <h2 className="text-xl text-gold font-bold tracking-widest uppercase mb-4" data-id="element-337">
            🔷 AVANZAPRO®
          </h2>
          <h3 className="text-4xl md:text-5xl font-black text-white mb-4 uppercase" data-id="element-338">
            SISTEMA LIBRE DE CLEARING
          </h3>
          <p className="text-2xl text-cream/90 font-medium mb-2" data-id="element-339">
            6 Tomos + 6 Bonos — Pack Completo
          </p>
          <p className="text-gold-gradient font-bold text-xl" data-id="element-340">
            470+ páginas — Todo resuelto.
          </p>
        </motion.div>

        <div className="text-center mb-12" data-id="element-341">
          <h4 className="text-2xl font-bold text-white flex items-center justify-center gap-2" data-id="element-342">
            <span className="text-3xl" data-id="element-343">🇺🇾</span> 6 TOMOS COMPLETOS — De la Deuda
            a la Libertad
          </h4>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-344">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-gradient-to-br ${tomo.color} to-brand-dark border border-gold/20 rounded-2xl p-6 relative overflow-hidden group hover:border-gold/50 transition-colors`} data-id="element-345">
              <div className="flex items-start gap-4" data-id="element-346">
                <div className="w-12 h-12 rounded-xl bg-brand-green border border-gold/30 flex items-center justify-center shrink-0 shadow-gold-glow" data-id="element-347">
                  <Book className="w-6 h-6 text-gold" data-id="element-348" />
                </div>
                <div data-id="element-349">
                  <div className="text-gold text-sm font-bold tracking-wider mb-1" data-id="element-350">
                    TOMO {tomo.num}
                  </div>
                  <h5 className="text-xl font-black text-white mb-2 uppercase" data-id="element-351">
                    {tomo.title}
                  </h5>
                  <p className="text-cream font-medium text-sm mb-3" data-id="element-352">
                    {tomo.subtitle}
                  </p>
                  <p className="text-cream/70 text-sm leading-relaxed" data-id="element-353">
                    {tomo.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-dark border border-gold/30 rounded-2xl p-6 md:p-8 shadow-gold-glow-lg" data-id="element-354">
          <div className="grid md:grid-cols-2 gap-4" data-id="element-355">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-356">
                <CheckCircle2 className="w-5 h-5 text-brand-success shrink-0 mt-0.5" data-id="element-357" />
                <span className="text-cream/90 text-sm md:text-base" data-id="element-358">
                  {feature}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}